import { useState } from "react";
import { Box, Flex } from "@mantine/core";
import { IconDownload, IconLink, IconMessage } from "@tabler/icons-react";
import { TFunction } from "i18next";

import { Button, CommentsModal, PublicLinkModal, Text } from "components";
import { AuthorityConstants, ServiceConstants } from "constant";
import { displayClasses } from "styles";
import { CardResponse } from "types"
import { UserUtils } from "utils";
import { CardService } from "services";

const { ROLE_USR_CMT, ROLE_CC_C } = AuthorityConstants;
const { REQUEST_CARDS_LINK_CREATE_ID } = ServiceConstants;

interface CardHeaderProps {
  card: CardResponse;
  t: TFunction;
}

const CardHeader = ({ card, t }: CardHeaderProps) => {
  const [commentsVisible, setCommentsVisible] = useState<boolean>(false);
  const [linkVisible, setLinkVisible] = useState<boolean>(false);

  return (
    <Flex justify={'space-between'} align={'center'} className={displayClasses.header}>
      <Text size={'xl'}>{card.user.fullName}</Text>
      <Flex>
        <Button variant={'transparent'} size={'compact-md'} onClick={() => {}}>
          <IconDownload color={'var(--mantine-color-gray-7)'} />
        </Button>
        {UserUtils.hasAuthority(ROLE_USR_CMT) &&
          <Box>
            <Button variant={'transparent'} size={'compact-md'} onClick={() => setCommentsVisible(true)}>
              <IconMessage color={'var(--mantine-color-gray-7)'} />
            </Button>
            <CommentsModal
              opened={commentsVisible}
              onClose={() => setCommentsVisible(false)}
              title={t('card.comment.title')}
              userId={card.user.id}
            />
          </Box>
        }
        <Button variant={'transparent'} size={'compact-md'} onClick={() => setLinkVisible(true)}><IconLink color={'var(--mantine-color-gray-7)'} /></Button>
        <PublicLinkModal
          opened={linkVisible}
          onClose={() => setLinkVisible(false)}
          create={() => CardService.cardLinkCreate(card.id)}
          requestId={REQUEST_CARDS_LINK_CREATE_ID}
          t={t}
          link={card.link}
          authority={ROLE_CC_C}
          object={'card'}
        />
      </Flex>
    </Flex>
  )
}

export default CardHeader;